







































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import ArrowDown from "./resources/arrowDown.vue";

// TODO document2
import { Document } from "@/model/document2/document";
import { Page } from "@/model/document2/page/page";

import { DebugHelper } from "@/helper/debugHelper";

import Save from "./resources/save.vue";
import Print from "./resources/print.vue";
import PdfSave from "./resources/pdfSave.vue";
import SelectSaveStorageModal from "@/commonComponents/alertModal/selectSaveStorageModal/selectSaveStorageModal.vue";
import PrintErrorModal from "./printErrorModal/printErrorModal.vue";

import { UserAgentHelper } from "@/helper/userAgentHelper";

@Component({
  components: {
      Print,
      PdfSave,
      Save,
      SelectSaveStorageModal,
      PrintErrorModal,
      DropdownList,
      ArrowDown
  }
})
export default class RightController extends Vue {
    @Prop() private document! : Document;
    @Prop() private printPageCount! : number;
    @Prop() private blankFrameCount! : number;

    private get productName() { return this.document.productName; }
    private get productCode() { return this.document.productCode; }
    private get surfaceNumber() { return this.document.surfaceNumber; }

    selectStorageModalShown = false;
    printErrorModalShown = false;
    isPrintQualityDropdownVisible = false;
    printQualityItems : Array<any> = [];
    printQualityText : string = "";

    mounted() 
    {
        this.updatePrintQualityItems();
        this.updatePrintQualityText();
    }

    private updatePrintQualityItems()
    {
        let isRaster = this.$store.getters.userConfig.printRaster;
        let quality = this.$store.getters.userConfig.printQuality;

        var items = new Array();
        items.push({
            id: 0,
            isSelected: !isRaster,
            label: "最高品質"
        });
        items.push({
            id: 1,
            isSelected: isRaster && quality == 1,
            label: "高品質(360dpi)"
        });
        items.push({
            id: 2,
            isSelected: isRaster && quality == 2,
            label: "標準(288dpi)"
        });
        items.push({
            id: 3,
            isSelected: isRaster && quality == 3,
            label: "低負荷(216dpi)"
        });
        this.printQualityItems = items;
    }

    private updatePrintQualityText()
    {
        let isRaster = this.$store.getters.userConfig.printRaster;
        let quality = this.$store.getters.userConfig.printQuality;
        if(!isRaster) this.printQualityText = "最高品質";
        else if(isRaster && quality == 1) this.printQualityText = "高品質(360dpi)";
        else if(isRaster && quality == 2) this.printQualityText = "標準(288dpi)";
        else if(isRaster && quality == 3) this.printQualityText = "低負荷(216dpi)";
        return "";
    }

    private selectPrintQuality(id : number, tag : string)
    {
        if(id == 0) this.setPrintQuality(false);
        else if(id == 1) this.setPrintQuality(true, 1);
        else if(id == 2) this.setPrintQuality(true, 2);
        else if(id == 3) this.setPrintQuality(true, 3);
        this.isPrintQualityDropdownVisible = false;
        this.updatePrintQualityItems();
        this.updatePrintQualityText();
    }

    private setPrintQuality(isRaster : boolean, quality : number = 1)
    {
        this.$store.getters.userConfig.printRaster = isRaster;
        this.$store.getters.userConfig.printQuality = quality;
    }

    private get isElectron()
    {
        return UserAgentHelper.isElectron();
    }

    private onDoCommand(command: string, paramater: any) {
        this.$emit("doCommand", command, paramater);
    }

    private onClickSavePDF() {
        this.onDoCommand("savePDF", null);
    }

    private onClickSaveDocument(){
        this.onDoCommand("saveDocument", null);
    }

    private onClickPrint() {
        this.onDoCommand("print", null);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }
    public get currentPage() : Page
    {
        var document = this.currentDocument;
        return document.pageList[document.currentPageIndex];
    }
    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
